module.exports = __webpack_public_path__ + "img/404_2.2ba84831.png";